Auth = require 'db/auth'
BoardListAnnouncementComponent = require 'views/board-list/board-list-announcement-component'
BoardsPageAnnouncement = require 'data/boards-page-announcement'
ChangeEmailFreqPopoverView = require 'views/member/change-email-freq-popover-view'
DesktopNotification = require 'lib/desktop-notification'
Dialog = require 'views/lib/dialog'
FilterState = require 'view-models/notification-filter-state'
InfiniteScroll = require 'views/lib/infinite-scroll'
MarketingOptInComponent = require 'views/marketing/marketing-opt-in-component'
ModelCache = require 'db/model-cache'
ModelCacheListener = require 'views/internal/model-cache-listener'
ModelLoader = require 'db/model-loader'
NoticeOfTosChange = require 'views/in-app-notif/notice-of-tos-change'
Notification = require 'models/notification'
NotificationGroup = require 'models/collections/notification-group'
NotificationList = require 'views/notification/notification-list'
NotificationsOnBoarding = require 'views/notification/notifications-onboarding'
NPSComponent = require 'views/nps/nps-component'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
SimpleTest = require 'lib/experiments/simple-test'
Storage = require 'lib/storage'
Util = require 'lib/util'
t = require('views/internal/recup-with-helpers')('header_notification_list_menu')
track = require 'debug/track'
trackUe = require 'debug/trackUe'
logError = require 'debug/log-error'
_ = require 'underscore'
$ = require 'jquery'
moment = require 'moment'

findOldestLoadedNotification = ->
  ModelCache.all('Notification').reduce((acc, curr) ->
    if !acc? || acc?.get('id') > curr?.get('id')
      return curr
  , null)

class HeaderNotificationListView extends React.Component
  displayName: 'HeaderNotifications'

  constructor: (props) ->
    this.isShowCards = SimpleTest('cardNotifications').get('showCards')
    this.state = _.extend {}, {
      canAllowDesktopNotifications: DesktopNotification.notEnabled()
      surveyDismissed: false
      visibilityFilter: Auth.me().getNotificationFilterState().getVisibility()
      isLoadingNotifications: false
    }, @getNotificationState()

  componentDidMount: ->
    @mounted = true
    @props.listenTo(
      'add:Notification remove:Notification change:Notification change:Member:oneTimeMessagesDismissed change:Board:prefs',
      _.debounce(@updateNotifications.bind(@), 100)
    )

    @infiniteScroll = new InfiniteScroll '.notification-list',
      scrollableContainer: '.notification-list-holder'

    @infiniteScroll.on 'nearEnd', =>
      @loadMore().then (isMore) =>
        @loadedAll = !isMore
        @resetOnNextRender = isMore

    # Ensures we try to load more data if the list is not scrollable
    @infiniteScroll.reset()

    @updateLastSeenNotification()

  componentDidUpdate: ->
    if @resetOnNextRender == true
      @resetOnNextRender = false
      @listAnimation ?= Promise.resolve()
      @listAnimation.then =>
        window.requestAnimationFrame (=> @infiniteScroll.reset())

  componentWillUnmount: ->
    @mounted = false
    @infiniteScroll.destroy()
    @_notificationPermissionPromise?.cancel()

  updateLastSeenNotification: =>
    @props.member.notificationsSeenState.setLastSeen()

  updateNotifications: ->
    # Quick hack around making sure this setState doesn't get called by the debounced method
    # Underscore never updated their debounce with a cancel method
    if @mounted
      @updateLastSeenNotification()
      @setState @getNotificationState()

  getNotificationState: ->
    if @isShowCards
      notifications = new NotificationGroup(ModelCache.all('Notification'))
      totalUnreadNotifications = notifications.totalUnreadNotifications()
    else
      notifications = Notification.sortedByDateDescending(ModelCache)
      totalUnreadNotifications = notifications.filter((notification) -> notification.get('unread')).length

    {
      notifications: notifications
      totalUnreadNotifications: totalUnreadNotifications
    }

  _getOrSet: (key, value) ->
    isSet = Storage.get key
    if !isSet?
      Storage.set key, value

    return isSet ? value

  getBanner:  ->
    banners = [
      {
        # Message is the same but it's a new survey
        name: 'notifications-bell-count-feedback'
        exp: SimpleTest('bellCount')
        message: ->
          # The banner and feedback form is not localized,
          # show a message to non english speakers to explain the
          # form is in english, but show the message in their language
          t.l 'notifications-grouped-card-feedback',
            url: "https://trello.typeform.com/to/FZlTPd?memberid=#{ Auth.myId() }&testvar=#{ @exp.get('variation') }"
            englishNote:
              if !Util.usesEnglish()
                t.l 'notifications-grouped-card-feedback-note-about-english'
              else ""
          , raw: true

        ttl: 300 # 5 minutes
      }
    ]

    banner = _.chain(banners)
      .filter((banner) -> banner.exp.inExperiment)
      .filter((banner) -> !Auth.me().isDismissed(banner.name))
      .last()
      .value()

    # Banner TTL = Time to live
    # How many seconds do we wait until we show the use the banner?
    if banner?.ttl
      timeToWait = @_getOrSet(
        "first-visit-#{banner.name}",
        moment().add(banner.ttl, 's')
      )
      if moment().isAfter(moment(timeToWait))
        banner
    else
      banner

  toggleVisibilityFilter: =>
    @loadedAll = false
    visibilityFilter = Auth.me().getNotificationFilterState().toggleVisibility()

    if !@loadPrevious
      @loadPrevious = Promise.resolve()
      if visibilityFilter == FilterState::VISIBILITY_ALL
        idOldestLoadedNotificaton  = findOldestLoadedNotification()?.get('id')
        if idOldestLoadedNotificaton? && @idOldestLoadedNotificaton != idOldestLoadedNotificaton
          @idOldestLoadedNotificaton = idOldestLoadedNotificaton
          @loadPrevious = ModelLoader.loadAllNotificationGroupsBefore(
            @idOldestLoadedNotificaton,
            Notification.PAGE_SIZE
          )

    @setState { visibilityFilter, isLoadingNotifications: true }, =>
      @loadPrevious.then =>
        @loadPrevious = null
        @idOldestLoadedNotificaton = findOldestLoadedNotification()?.get('id')
        @resetOnNextRender = true
        @setState { isLoadingNotifications: false }

    trackUe(
      'header'
      if visibilityFilter == FilterState::VISIBILITY_UNREAD then 'shows unread' else 'shows all'
      'notifications'
      'on notifications menu'
      ''
      'by clicking filter toggle button'
    )

  renderOtherComponents: ->
    # sometimes we want to render components to be shown at the top of the
    # notifications pane - such as a survey. this needs to be done in the same
    # element as the empty state or notifications list so that it will scroll
    # with the notifs - otherwise the notifs will be cut off at the bottom
    if @props.showNoticeOfTosChange
      t.createElement NoticeOfTosChange

    if @props.showMarketingOptIn
      t.createElement MarketingOptInComponent, {
        setMarketingOptIn: @props.setMarketingOptIn
      }

    if @props.showSurvey && !@state.surveyDismissed
      t.createElement NPSComponent, {
        username: Auth.me()?.get('username')
        onDismiss: =>
          @setState(surveyDismissed: true)
          @props.onDismissSurvey()
        submitSurvey: @props.submitSurvey
      }

  render: t.renderable ->
    { canAllowDesktopNotifications
    , notifications
    , surveyDismissed
    , totalUnreadNotifications
    , isLoadingNotifications } = @state

    exp = SimpleTest('cardNotifications')
    showOnboarding = (exp.get('showCards')) && !Auth.me().isDismissed('notifications-onboarding')

    t.div
      class: t.classify
        'notifications-onboarding': showOnboarding
    , =>
      t.div '.notifications-title', =>
        t.span ->
          t.format 'notifications'
        t.button '.hide-dialog-trigger.dialog-close-button.unstyled-button', {
          onClick: @onHideDialogTriggerClick.bind @
          type: 'button'
        }, =>
          t.icon 'close'

      t.div
        class: t.classify
          'notification-list-holder': true,
          'u-fancy-scrollbar': true,
          'show-cards': @isShowCards
      , =>
        if notifications.length == 0 && !@isShowCards
          @renderOtherComponents()
          t.p '.empty', { style: { padding: '24px 6px' } }, ->
            t.format 'no-notifications'

        if !@isShowCards
          # If we're not in the experiment, we still want to render any
          # addition components
          @renderOtherComponents()

        if @isShowCards
          @renderOtherComponents()
          t.div '.notification-actions', =>
            t.button '.visibility-filter.quiet.unstyled-button', {
              href: '#',
              onClick: @toggleVisibilityFilter
            }, =>
              if @state.visibilityFilter == FilterState::VISIBILITY_UNREAD
                t.format 'visibility-filter-all'
              else
                t.format 'visibility-filter-unread'

            if totalUnreadNotifications > 0
              t.button '.mark-all-read.quiet.unstyled-button', {
                href: '#',
                onClick: =>
                  trackUe(
                    'header'
                    'marks as read'
                    'all notifications'
                    'on notifications menu'
                    ''
                    'by clicking mark all as read button'
                  )
                  @props.markAllRead()
              }, ->
                t.format 'mark-all-as-read'

        banner = @getBanner()
        if banner?
          t.createElement BoardListAnnouncementComponent, {
            icon: BoardsPageAnnouncement.icon
            message: banner.message()
            onClick: (e) =>
              if e.target.href?
                track("Notifications Announcement", "Click", banner.name, e.target.href)
            onDismiss: =>
              Auth.me().dismiss(banner.name)
              track("Notifications Announcement", "Dismiss", banner.name)
          }

        fnResolve = -> null
        t.createElement NotificationList, {
          notifications,
          context: 'header',
          key: 'NotificationList',
          visibilityFilter: @state.visibilityFilter,
          visibilityButtonClicked: @toggleVisibilityFilter
          onAnimationStart: =>
            @listAnimation = new Promise (resolve) => fnResolve = resolve
          onAnimationEnd: =>
            fnResolve()
            # We're removing elements from the list, so the list will shrink
            # without a scroll event firing. We need to reset the infinite scroll
            # to ensure that we're loading new items as needed
            if @state.visibilityFilter == FilterState::VISIBILITY_UNREAD
              @infiniteScroll.reset()
        }

        t.div {
          class: t.classify({
            'notification-spinner': true,
            'loading': true,
            'spinner': isLoadingNotifications,
          })
        }
        t.ul '.pop-over-list.mod-add-top-margin', =>
          t.li =>
            t.a '.js-change-email-frequency', { onClick: @changeEmailFrequency.bind(@) }, ->
              t.format 'change-notification-email-frequency'

          if canAllowDesktopNotifications
            t.li =>
              t.a '.js-allow-desktop-notifications', { onClick: @allowDesktopNote.bind(@) }, ->
                t.format 'allow-desktop-notifications'

      if @isShowCards && !Auth.me().isDismissed('notifications-onboarding')
        t.createElement NotificationsOnBoarding

  changeEmailFrequency: (e) ->
    Util.stop(e)
    trackUe(
      'header'
      'changes'
      'email frequency'
      ''
      'from notifications menu'
      'by clicking the Change Notification Email Frequency button in notifications menu'
    )

    PopOver.toggle
      elem: $(e.target)
      view: new ChangeEmailFreqPopoverView({ model: @props.member, modelCache: ModelCache })

    return

  loadMore: ->
    if @mounted && !@loadedAll && @lockedFor != @state.visibilityFilter
      @lockedFor = @state.visibilityFilter
      @setState
        isLoadingNotifications: true
      limit = Notification.PAGE_SIZE
      fxLoad =
        if @isShowCards
          if @state.visibilityFilter == FilterState::VISIBILITY_ALL
            ModelLoader.loadMoreNotificationGroupData
          else
            ModelLoader.loadMoreUnreadNotifications
        else
          ModelLoader.loadMoreNotificationData
      fxLoad.call(ModelLoader, @props.member.get('username'), limit)
      .then (notifications) =>
        @lockedFor = null
        if @mounted
          @setState
            isLoadingNotifications: false
        @updateLastSeenNotification()
        return (notifications?.length || 0) == limit
    else
      Promise.resolve(false)

  allowDesktopNote: (e) ->
    Util.stop(e)
    trackUe(
      'header'
      'enables'
      'desktop notifications'
      ''
      'from notifications menu'
      'by clicking the Allow Desktop Notifications button in notifications menu'
    )

    @_notificationPermissionPromise =
      DesktopNotification.requestPermission()
      .then((__) => @setState canAllowDesktopNotifications: DesktopNotification.notEnabled())
      .catch(=> @setState canAllowDesktopNotifications: false)
      .cancellable()

    return

  onHideDialogTriggerClick: (e) ->
    Util.stop e
    Dialog.hide()

module.exports = ModelCacheListener(HeaderNotificationListView)



// WEBPACK FOOTER //
// ./app/scripts/views/notification/header-notification-list-view.coffee